import React, { useState, useEffect, useCallback,useContext } from 'react';

import Banner from '../../component/Common/Banner'
import LeftSideBar from '../../component/Shop/LeftSideBar'
import InstgramSlider from '../../component/Common/Instagram'
import { connect } from "react-redux";
import * as actions from "../../actions/service";
import * as category from "../../actions/category";
import * as user from "../../actions/user";
import * as department from "../../actions/department";
import _ from 'lodash'
import { AuthContext } from '../../context/AuthContext';
import ErrorArea from '../../component/Error';

const ShopLeftSideBar = (props) => {
    const { logout, getAuthUser,getCurrentBranch } = useContext(AuthContext)
    const authUser = getAuthUser()
    const currentBranch =getCurrentBranch()
    const [services, setServices] = useState([]);
    const [sort, setSort] = useState('all');
    const [title, setTitle] = useState('');

    const [myCart, setMycart] = useState(props.cartArray);
    const [isLoading, SetIsLoading] = useState(true);

    useEffect(() => {
        const onSuccess = () => {
          SetIsLoading(false)
        }
      
        props.fetchCart(authUser?.id)
        props.fetchAll({type:props.location.state.type,status: 'active'},onSuccess);
        props.fetchCategories();
        setMycart(props.cartArray)

             switch (props.location.state.type) {
                case 'product':
                  setTitle('Services')
                  break;
                case 'package':
                  setTitle('Packages')
                    break;
                case 'item':
                  setTitle('Products')
                  break;
                  case 'coupon':
                    setTitle('Coupons')
                  break;
               
              }
    
      }, [props.location.state.type]);
    return (
        <>
        
            {/* <Banner title={title}/> */}
           {isLoading || props.services.length===0? 
           <ErrorArea count={props.services.length} isLoading={isLoading}/>:
           <LeftSideBar title={title} {...props}/>}
            
            {/* <InstgramSlider />
        */}
        </>
    )
}

//export default ShopLeftSideBar

const mapStateToProps = state => ({
    services: state?.service?.services,
    meta: state?.service?.metaService,
    categories: state.category.categories,
    departments: state.department.departments,
    users: state.user.users,
    cart: state.user.cart,
    cartArray: state.user.cartArray
  })
  
  const mapActionToProps = {
    fetchAll: actions.getFilteredAllServices,
    update: actions.update,
    fetchCategories: category.fetchAll,
    fetchDepartments: department.fetchAll,
    updateUser: user.update,
    updateUserCart: user.updateCart,
    fetchCart: user.fetchCart
  }
  
  export default connect(mapStateToProps, mapActionToProps)(ShopLeftSideBar);